import { get, isEmpty } from 'lodash';
import numeral from 'numeral';
import { extractValue, maxScore } from './shared';

const formatMobilityScores = ({ data = [] } = {}) => {
  if (isEmpty(data)) {
    return null;
  }

  const mobilityData = get(data, 0, []);
  const max = maxScore(mobilityData);

  return [
    {
      label: 'Phone',
      value: `${extractValue(mobilityData, 'phonePercent')}%`,
      subValue: `${numeral(get(mobilityData, 'phoneVotes', '-')).format(
        '0,0'
      )} votes`,
      top: mobilityData.phonePercent === max
    },
    {
      label: 'Tablet',
      value: `${extractValue(mobilityData, 'tabletPercent')}%`,
      subValue: `${numeral(get(mobilityData, 'tabletVotes', '-')).format(
        '0,0'
      )} votes`,
      top: mobilityData.tabletPercent === max
    },
    {
      label: 'Computer',
      value: `${extractValue(mobilityData, 'computerPercent')}%`,
      subValue: `${numeral(get(mobilityData, 'computerVotes', '-')).format(
        '0,0'
      )} votes`,
      top: mobilityData.computerPercent === max
    },
    {
      label: 'TV',
      value: `${extractValue(mobilityData, 'tvPercent')}%`,
      subValue: `${numeral(get(mobilityData, 'tvVotes', '-')).format(
        '0,0'
      )} votes`,
      top: mobilityData.tvPercent === max
    }
  ];
};

export default formatMobilityScores;
